export const CATEGORIES = [
  { id: "celulares", label: "Celulares" },
  { id: "laptops", label: "Laptops" },
  { id: "audio", label: "Audio" },
  { id: "consolas", label: "Consolas/Gaming" },
  { id: "smartwatch", label: "Smartwatch" },
  { id: "accesorios", label: "Accesorios" },
  { id: "otros", label: "Otros" },
];

// Legacy category values stored in DB before the fixed category list existed
const LEGACY_MAP = {
  smartphones: "celulares",
  gaming: "consolas",
  wearables: "smartwatch",
  tablets: "otros",
  tecnologia: "otros",
  Otros: "otros",
};

export const normalizeCategory = (cat) => {
  if (!cat) return "otros";
  if (LEGACY_MAP[cat]) return LEGACY_MAP[cat];
  return CATEGORIES.some((c) => c.id === cat) ? cat : "otros";
};

export const categoryLabel = (cat) => {
  const norm = normalizeCategory(cat);
  return CATEGORIES.find((c) => c.id === norm)?.label || "Otros";
};
